import { usePlayerGraphList } from "../../../../rx/memo/usePlayerGraphList"
import type { Nullable } from "../../../../typescript"
import findByIdOrThrow from "../../findByIdOrThrow"
import type { PlayerId } from "../../player/PlayerId"
import type { Engine } from "../Engine.type"
import type { PlayerGraphNode } from "./PlayerGraphNode.type"

export default function getPlayerGraphNode(engine: Engine, playerId: Nullable<PlayerId>): PlayerGraphNode {
  const pgList = usePlayerGraphList(engine)
  if (playerId) {
    return findByIdOrThrow(pgList(), playerId)
  }
  // why are we returning first instead of null?
  return pgList()[0]
}